<template>
    <abstract-dropdown-container v-model="selectedValue" :options="{...defaultOptions, ...options}">
        <template v-slot:hint-top>
            <slot name="hint-top"></slot>
        </template>
        <template v-slot:hint-bottom>
            <slot name="hint-bottom"></slot>
        </template>
    </abstract-dropdown-container>
</template>

<script>
import {ORDER_ASSIGNMENT_METHODS_LIST as CRUD_ACTION_LIST} from 'actions/orders';

    export default {
        name: "FieldsDropdownOrderAssignmentMethods",
        props: {
            value: {},
            options: {
                type: Object,
                default: () => {}
            }
        },
        data() {
            return {
                selectedValue: this.value,
                defaultOptions: {
                    id:                                     "order_assignment_methods",
                    prepareResponseDataHandler:             this.prepareResponseData,
                    customLabelHandler:                     this.customLabel,
                    action:                                 CRUD_ACTION_LIST,
                }
            }
        },
        watch: {
            value: function (newVal, oldVal) {
                this.selectedValue = newVal;
            },
            selectedValue: function (newVal, oldVal) {
                this.$emit('input', newVal);
            }
        },
        methods: {
            customLabel(value) {
              return this.$i18n.t(`orders.lists.assignment_method.${value.name}`);
            },
            prepareResponseData(data) {
                let preparedData = [];
                for (const [key, value] of Object.entries(data)) {
                    preparedData.push({'id': value, 'name': `${value}`});
                }
                return preparedData;
            }
        }
    }
</script>

<style scoped>

</style>
